import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { CTMTContract, monstaTokenContract, odMnstaContract, odMnstConAdd, sCTMTConAdd, sCTMTContract, 
         stakingConAdd, stakingContract } from "./ConAddsAndABIs";

function Staking(){

    const [walletAddress, setWalletAddress] = useState("");
    const [sCTMTStakeValue, setSCTMTStakeValue] = useState('');
    const [sCTMTUnstakeValue, setSCTMTUnstakeValue] = useState('');
    const [cMnstaStakeValue, setCMnstaStakeValue] = useState('');
    const [cMnstaUnstakeValue, setCMnstaUnstakeValue] = useState('');
    const [odMnstStakeValue, setOdMnstStakeValue] = useState('');
    const [odMnstUnstakeValue, setodMnstUnstakeValue] = useState('');
    const [prematureSaleValue, setPrematureSaleValue] = useState('');
    const [ctmtBalance, setCtmtBalance] = useState('');
    const [ctmtBackingOfSCtmt, setCtmtBackingOfSCtmt] = useState('');
    const [ctmtBackingOfCMnsta, setCtmtBackingOfCMnsta] = useState('');
    const [ctmtBackingOfOdMnst, setCtmtBackingOfOdMnst] = useState('');
    const [monstaForOpalBBB, setMonstaForOpalBBB] = useState('');
    const [monstaForCrystalBBB, setMonstaForCrystalBBB] = useState('');

    const [sctmtBalance, setSctmtBalance] = useState('');
    const [cMnstaBalance, setCMnstaBalance] = useState('');
    const [odMnstBalance, setOdMnstBalance] = useState('');
    const [monstaBalance, setMonstaBalance] = useState('');


    const [sctmtTotalSupply, setSctmtTotalSupply] = useState('');
    const [cMnstaTotalSupply, setCMnstaTotalSupply] = useState('');
    const [odMnstotalSupply, setOdMnstTotalSupply] = useState('');
    const [sctmtPrice, setSctmtPrice] = useState('');
    const [ctmtPremiumOfCMnsta, setCtmtPremiumOfCMnsta] = useState('');
    const [ctmtPremiumOfOdMnst, setCtmtPremiumOfOdMnst] = useState('');

    const [odMnstVaultTime, setOdMnstVaultTime] = useState('');
    const [odMnstVaultTimeButton, setOdMnstVaultTimeButton] = useState('');
    const [odMnstResetTime, setOdMnstResetTime] = useState('');
    const [odMnstResetButton, setOdMnstResetButton] = useState('');
    const [cMnstaResetTime, setCMnstaResetTime] = useState('');
    const [cMnstaResetButton, setCMnstaResetButton] = useState('');    

    useEffect(() => {  
 
        const getWalletAddress = async () => {
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const account = accounts[0]
            const accountF = account.toString()
            setWalletAddress(accountF);
        }

        getWalletAddress()
            .catch(console.error)    

        const getCtmtBalance = async () => {
            const data = await CTMTContract.balanceOf(walletAddress) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
              setCtmtBalance(dataF)
        }
    
        getCtmtBalance()
            .catch(console.error)   
            
        const getMonstaBalance = async () => {
            const balance = await monstaTokenContract.balanceOf(walletAddress)
            const balanceFormatted = balance / (10**18)
            const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMonstaBalance(commaSeparated)
            }
    
            getMonstaBalance()
                .catch(console.error) 

        const getsCtmtBalance = async () => {
            const data = await sCTMTContract.balanceOf(walletAddress) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setSctmtBalance(dataF)
        }
    
        getsCtmtBalance()
            .catch(console.error)  
            
        const getCMnstaBalance = async () => {
            const data = await stakingContract.balanceOf(walletAddress) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCMnstaBalance(dataF)
        }
    
        getCMnstaBalance()
            .catch(console.error) 

        const getOdMnstBalance = async () => {
            const data = await odMnstaContract.balanceOf(walletAddress) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setOdMnstBalance(dataF)
        }
    
        getOdMnstBalance()
            .catch(console.error)             
            
        const getSctmtPrice = async () => {
            const data = await sCTMTContract.getSCTMTPrice() / 1000000000000000000000000000
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4})
                setSctmtPrice(dataF)
        }
    
        getSctmtPrice()
            .catch(console.error)      

        const getCtmtPremiumOfCMnsta = async () => {
            const data = await stakingContract.getCTMTPremium() / 1000000000000000000000000000
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4})
                setCtmtPremiumOfCMnsta(dataF)
        }
    
        getCtmtPremiumOfCMnsta()
            .catch(console.error)   
            
        const getCtmtPremiumOfOdMnst = async () => {
            const data = await odMnstaContract.getCTMTPremium() / 1000000000000000000000000000
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4})
                setCtmtPremiumOfOdMnst(dataF)
        }
    
        getCtmtPremiumOfOdMnst()
            .catch(console.error)             
            
        const getCtmtBackingOfSCtmt = async () => {
            const data = await CTMTContract.balanceOf(sCTMTConAdd) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCtmtBackingOfSCtmt(dataF)
        }
    
        getCtmtBackingOfSCtmt()
            .catch(console.error)    
            
        const getCtmtBackingOfCMnsta = async () => {
            const data = await CTMTContract.balanceOf(stakingConAdd) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCtmtBackingOfCMnsta(dataF)
        }
    
        getCtmtBackingOfCMnsta()
            .catch(console.error)    

        const getCtmtBackingOfOdMnst = async () => {
            const data = await CTMTContract.balanceOf(odMnstConAdd) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCtmtBackingOfOdMnst(dataF)
        }

        getCtmtBackingOfOdMnst()
            .catch(console.error)   

        const monstaForBBB = async () => {
            const data1 = await monstaTokenContract.balanceOf(odMnstConAdd) / (10**18)
            const data2 = await monstaTokenContract.balanceOf(stakingConAdd) / (10**18)
            const data1F = data1.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const data2F = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMonstaForCrystalBBB(data1F)
                setMonstaForOpalBBB(data2F)
        }              

        monstaForBBB()
            .catch(console.error) 

        const getSctmtTotalSupply = async () => {
            const data = await sCTMTContract.totalSupply() / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setSctmtTotalSupply(dataF)
        }
    
        getSctmtTotalSupply()
            .catch(console.error)              

        const getCMnstaTotalSupply = async () => {
            const data = await stakingContract.totalSupply() / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCMnstaTotalSupply(dataF)
        }
    
        getCMnstaTotalSupply()
            .catch(console.error)     

        const getOdMnstTotalSupply = async () => {
            const data = await odMnstaContract.totalSupply() / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setOdMnstTotalSupply(dataF)
        }
    
        getOdMnstTotalSupply()
            .catch(console.error) 

        const getOdMnstOpenTime= async () => {
            const vStat = await odMnstaContract.isBMonstaVaultOpen()
            const oTime = await odMnstaContract.openTime()
            const oTimeF1 = new Date(oTime * 1000)
            const oTimeF2 = "Opening: " + oTimeF1.toString()
            const cTime = await odMnstaContract.closingTime()
            const cTimeF1 = new Date(cTime * 1000)   
            const cTimeF2 = "Closing: " + cTimeF1.toString()

            if (vStat === false) {
                setOdMnstVaultTime(oTimeF2) 
                setOdMnstVaultTimeButton(<button onClick={handleOdMnstOpen}>Open</button>)
            } else if (vStat === true) {
                setOdMnstVaultTime(cTimeF2)
                setOdMnstVaultTimeButton(<button onClick={handleOdMnstClose}>Close</button>)
            }
                            
        }
        
        getOdMnstOpenTime()
            .catch(console.error)  


        const getOdMnstResetTimie= async () => {
            const cTime = await odMnstaContract.resetStartDate()
            const cTimeF1 = new Date(cTime * 1000)   
            const cTimeF2 = cTimeF1.toString()
                setOdMnstResetTime(cTimeF2)
                setOdMnstResetButton(<button onClick={handleOdMnstReset}>Reset</button>)           
        }
        
        getOdMnstResetTimie()
            .catch(console.error)  

        const getCMnstaResetTime= async () => {

            const cTime = await stakingContract.resetStartDate()
            const cTimeF1 = new Date(cTime * 1000)   
            const cTimeF2 = cTimeF1.toString()
                setCMnstaResetTime(cTimeF2)
                setCMnstaResetButton(<button onClick={handlecMnstReset}>Reset</button>)           
        }
        
        getCMnstaResetTime()
            .catch(console.error)            

    })       


    const handleCTMTApproval = async (e) => {
        e.preventDefault();
        const allow = '1000000000000'
        console.log(allow)
        const uintValue = ethers.utils.parseUnits(allow, 18)
        const txn = await CTMTContract.approve(sCTMTConAdd, uintValue)
        await txn.wait();
        }  
    
    const handleSctmtStakeChange = (e) => {
        setSCTMTStakeValue(e.target.value);
        }
    
    const handleSctmtStakeSubmit = async (e) => {
        e.preventDefault();
        console.log(sCTMTStakeValue)

        const uintValue = ethers.utils.parseUnits(sCTMTStakeValue, 18)
        const txn = await sCTMTContract.stakeCTMT(uintValue)
        await txn.wait();
        setSCTMTStakeValue(0);}

    const handleSctmtUnstakeChange = (e) => {
        setSCTMTUnstakeValue(e.target.value);
        }
    
    const handleSctmtUnstakeSubmit = async (e) => {
        e.preventDefault();
        console.log(sCTMTUnstakeValue)
        const uintValue = ethers.utils.parseUnits(sCTMTUnstakeValue, 18)
        const txn = await sCTMTContract.unStakeCTMT(uintValue)
        await txn.wait();
        setSCTMTUnstakeValue(0);}        

    const handleCTMTApprovalForCMnsta = async (e) => {
        e.preventDefault();
        const allow = '1000000000000'
        console.log(allow)
        const uintValue = ethers.utils.parseUnits(allow, 18)
        const txn = await CTMTContract.approve(stakingConAdd, uintValue)
        await txn.wait();
        }  
    
    const handleMonstaApprovalForCMnsta = async (e) => {
        e.preventDefault();
        const allow = '1000000000000'
        console.log(allow)
        const uintValue = ethers.utils.parseUnits(allow, 18)
        const txn = await monstaTokenContract.approve(stakingConAdd, uintValue)
        await txn.wait();
        }  

    const handleCMnstaStakeChange = (e) => {
        setCMnstaStakeValue(e.target.value);
        }
    
    const handleCMnstaStakeSubmit = async (e) => {
        e.preventDefault();
        console.log(cMnstaStakeValue)

        const uintValue = ethers.utils.parseUnits(cMnstaStakeValue, 18)
        const txn = await stakingContract.stakeMonsta(uintValue)
        await txn.wait();
        setCMnstaStakeValue(0);}


    const handleCMnstaUnstakeChange = (e) => {
        setCMnstaUnstakeValue(e.target.value);
        }
    
    const handleCMnstaUnstakeSubmit = async (e) => {
        e.preventDefault();
        console.log(cMnstaUnstakeValue)
        const uintValue = ethers.utils.parseUnits(cMnstaUnstakeValue, 18)
        const txn = await stakingContract.unStakeMonsta(uintValue)
        await txn.wait();
        setCMnstaUnstakeValue(0);}   

    const handleCTMTApprovalForOdMnst = async (e) => {
        e.preventDefault();
        const allow = '1000000000000'
        console.log(allow)
        const uintValue = ethers.utils.parseUnits(allow, 18)
        const txn = await CTMTContract.approve(odMnstConAdd, uintValue)
        await txn.wait();
        }  
    
    const handleMonstaApprovalForOdMnst = async (e) => {
        e.preventDefault();
        const allow = '1000000000000'
        console.log(allow)
        const uintValue = ethers.utils.parseUnits(allow, 18)
        const txn = await monstaTokenContract.approve(odMnstConAdd, uintValue)
        await txn.wait();
        }  

    const handleOdMnstStakeChange = (e) => {
        setOdMnstStakeValue(e.target.value);
        }
    
    const handleOdMnstStakeSubmit = async (e) => {
        e.preventDefault();
        console.log(odMnstStakeValue)

        const uintValue = ethers.utils.parseUnits(odMnstStakeValue, 18)
        const txn = await odMnstaContract.subsribeOdMnst(uintValue)
        await txn.wait();
        setOdMnstStakeValue(0);}


    const handleOdMnstUnstakeChange = (e) => {
        setodMnstUnstakeValue(e.target.value);
        }
    
    const handleOdMnstUnstakeSubmit = async (e) => {
        e.preventDefault();
        console.log(odMnstUnstakeValue)
        const uintValue = ethers.utils.parseUnits(odMnstUnstakeValue, 18)
        const txn = await odMnstaContract.unSubsribeOdMnst(uintValue)
        await txn.wait();
        setodMnstUnstakeValue(0);}  
        

    const handlecMnstReset = async (e) => {
        e.preventDefault();
        const txn = await stakingContract.resetMonsta()
        await txn.wait();}          

    const handleOdMnstReset = async (e) => {
        e.preventDefault();
        const txn = await odMnstaContract.resetMonsta()
        await txn.wait();}  

    const handleOdMnstOpen = async (e) => {
        e.preventDefault();
        const txn = await odMnstaContract.openBMonstaVault()
        await txn.wait();}  

    const handleOdMnstClose = async (e) => {
        e.preventDefault();
        const txn = await odMnstaContract.closeBmonstaVault()
        await txn.wait();}          

    const handlePrematureSaleChange = (e) => {
        setPrematureSaleValue(e.target.value);
        }

    const handlePrematureSaleSubmit = async (e) => {
        e.preventDefault();
        console.log(prematureSaleValue)
        const uintValue = ethers.utils.parseUnits(prematureSaleValue, 18)
        const txn = await odMnstaContract.ForceUnSubsribeOdMnst(uintValue)
        await txn.wait();
        setPrematureSaleValue(0);}  

    return(
        <div>
            <div className="row">
                <div className="side">
                    <h2 style={{"textAlign":"center"}}>UNDER CONSTRUCTION</h2>

                </div>

            </div>
        </div>
        
    )
}

export default Staking;